const GremlinNormal = ({size}) => (
  <img
    alt="Logo"
    src="/static/gremlin_normal_256.png"
    style={{height: size}}
  />
);

export default GremlinNormal;
